import withProgress from 'core/components/progress/withProgress'
import Dropdown from 'core/elements/dropdown'
import useListAction from 'core/hooks/useListAction'
import { listResmgrHosts } from 'openstack/components/infrastructure/actions'
import { resmgrHostsById } from 'openstack/components/infrastructure/selectors'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { listStoragePools } from './actions'
import { storagePoolsSelector } from './selectors'

const AsyncDropdown = withProgress(Dropdown, { inline: true })

export default function storagePoolsPicklist({
  disabled = false,
  name = 'storagePools',
  label = 'Storage Backends',
  includeNoneOption = false,
  filterFn = null,
  ...rest
}) {
  const { loading } = useListAction(listStoragePools)
  const storagePools = useSelector(storagePoolsSelector)
  const { loading: loadingHosts } = useListAction(listResmgrHosts)
  const hosts = useSelector(resmgrHostsById)

  const options = useMemo(() => {
    const storagePoolOptions = storagePools.map((storagePool) => {
      const withoutPoolName = storagePool?.name?.split('#')?.[0]
      const [hostId, backend] = withoutPoolName?.split('@')
      const hostname = hosts(hostId)?.info?.hostname || hostId
      return {
        label: `Host ${hostname} on backend ${backend}`,
        value: storagePool.name,
      }
    })

    const filteredOptions = filterFn ? filterFn(storagePoolOptions) : storagePoolOptions
    return includeNoneOption ? [{ label: 'None', value: '' }, ...filteredOptions] : filteredOptions
  }, [storagePools, hosts, includeNoneOption, filterFn])

  return (
    <AsyncDropdown
      {...rest}
      name={name}
      label={label}
      compact={false}
      disabled={disabled}
      loading={loading || loadingHosts}
      items={options}
    />
  )
}
